import { FC, ReactNode, useState } from 'react';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

export const BaseTooltip: FC<{
  children?: ReactNode;
  content?: ReactNode;
  timeTooltip?: boolean;
  asChild?: boolean;
  enable?: boolean;
  underline?: boolean;
  className?: string;
}> = ({
  children,
  content,
  timeTooltip = false,
  asChild = false,
  enable = true,
  underline = true,
  className,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const triggerClass = cn(
    underline &&
      'cursor-pointer underline decoration-dotted underline-offset-4',
    className,
  );
  return (
    <TooltipProvider>
      <Tooltip delayDuration={0} open={isOpen} onOpenChange={setIsOpen}>
        <TooltipTrigger
          onClick={() => setIsOpen(!isOpen)}
          className={triggerClass}
          tabIndex={0}
          asChild={asChild}
          role="button"
          aria-label={
            timeTooltip ? 'Show UTC time information' : 'Show more information'
          }
        >
          {children}
        </TooltipTrigger>
        {enable && (
          <TooltipContent
            className="flex items-center gap-2 max-sm:max-w-[320px]"
            onPointerDownOutside={() => setIsOpen(false)}
          >
            {content} {timeTooltip && <p>UTC</p>}
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
};
